<span
  class="ui-avatar ui-avatar--{{ size() }}"
  [style.background-color]="backgroundColor()"
  [attr.title]="name() || null"
  [attr.aria-label]="name() || 'Avatar'"
>
  @if (src()) {
    <img class="ui-avatar__img" [src]="src()" [alt]="name()" />
  } @else {
    <span class="ui-avatar__initials">{{ initials() }}</span>
  }
</span>
